import { connect } from 'react-redux'
import { get } from 'lodash'

import {
  changeReportCar as onChangeReportCar,
  clearReportCar as onClearReportCar
} from '../../actions/reportCarActions'

const mapStateToProps = state => ({
  reportCarId: get(state, ['reportCar', 'id'], '')
})

const mapDispatchToProps = {
  onChangeReportCar,
  onClearReportCar
}

const withReportCar = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withReportCar }